export default {
  computed: {
    query() {
      return this.$query.parse(window.location.search)
    }
  },
  methods: {
    queryObject() {
      return this.$query.parse(window.location.search)
    },
    queryExcept(exceptions) {
      let query = { ...this.queryObject() }
      exceptions.forEach(exception => {
        delete query[exception]
      })

      return query
    },
    addToQuery(params, query) {

      if (query === undefined) {
        query = { ...this.queryObject() }
      }

      let urlParams = Object.assign(query, params)

      this.$inertia.visit(
        route(route().current(), urlParams)
      )
    },
    removeFromQuery(params, query) {
      if (query === undefined) {
        query = { ...this.queryObject() }
      }

      params.forEach(param => {
        delete query[param]
      })

      this.$inertia.visit(
        route(route().current(), query)
      )
    },
    changePage(page, route) {
      let query = { ...this.queryObject() }
      query.page = page;

      if (route === undefined) {
        route = this.route().current()
      }

      this.$inertia.visit(this.route(route), {
        data: query
      })
    },
  }
}